import { render, staticRenderFns } from "./AssignmentPreview.vue?vue&type=template&id=4a5f7908&scoped=true&"
import script from "./AssignmentPreview.vue?vue&type=script&lang=ts&"
export * from "./AssignmentPreview.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentPreview.vue?vue&type=style&index=0&id=4a5f7908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f7908",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
